import React from 'react';
import {
	BaseEdge,
	EdgeLabelRenderer,
	getBezierPath,
	useReactFlow,
} from 'reactflow';

import './buttonedge.css';
import { useDispatch } from 'react-redux';

export default function CustomEdge({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	style = {},
	markerEnd,
}) {
	const { setEdges } = useReactFlow();
	const [edgePath, labelX, labelY] = getBezierPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});
	const dispatch = useDispatch();

	const onEdgeClick = () => {
		dispatch({
			type: 'SHOW_BUTTON',
			payload: {
				show: true,
			},
		});
		setEdges((edges) => edges.filter((edge) => edge.id !== id));
	};

	return (
		<>
			<BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
			<EdgeLabelRenderer>
				<div
					style={{
						position: 'absolute',
						transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
						fontSize: 12,
						pointerEvents: 'all',
					}}
					className='nodrag nopan'
				>
					<button className='edgebutton' onClick={onEdgeClick}>
						×
					</button>
				</div>
			</EdgeLabelRenderer>
		</>
	);
}
